import { useQuery } from '@tanstack/react-query';
import { api } from 'src/constants/apiRoutes';
import { queryKeys } from 'src/constants/querykeys';
import { Catalog, CatalogTreeViewItem } from 'src/types/catalog';
import axiosInstance from 'src/utils/axios';
import { transformCatalogsToTreeData } from 'src/utils/tansformCatalogsToTreeData';

async function fetchCatalogs(): Promise<CatalogTreeViewItem[]> {
  const res = await axiosInstance.get<Catalog[]>(api.getCatalogs);
  return transformCatalogsToTreeData(res.data);
}

const useGetCatalogsQuery = () => {
  const query = useQuery<CatalogTreeViewItem[]>({
    queryKey: [...queryKeys.product.catalogs()],
    queryFn: fetchCatalogs,
  });

  return query;
};

export default useGetCatalogsQuery;
